module.exports = __webpack_public_path__ + "img/selectOthersLibrary.a8aa6a9f.png";